import { apiClient } from './client';

// Types
export interface ResolvedLink {
  assessment_id: string;
  assessment_title: string;
  assessment_description: string | null;
  assessment_type: string;
  question_count: number;
  time_limit_minutes: number | null;
  tutor_name: string;
}

export interface EnrollResult {
  enrollment_id: string;
  assessment_id: string;
  course_id: string;
}

export interface ShortLink {
  id: string;
  short_code: string;
  assessment_id: string;
  course_id: string;
  label: string | null;
  is_active: boolean;
  max_uses: number | null;
  use_count: number;
  expires_at: string | null;
  created_at: string;
}

export interface CreateLinkRequest {
  assessment_id: string;
  label?: string;
  max_uses?: number;
  expires_at?: string;
}

// PUBLIC - no auth needed (uses apiClient which handles base URL)
export async function resolveTestLink(code: string): Promise<ResolvedLink> {
  return apiClient.get<ResolvedLink>(`/test-links/${code}`);
}

// Authenticated
export async function enrollViaTestLink(code: string): Promise<EnrollResult> {
  return apiClient.post<EnrollResult>(`/test-links/${code}/enroll`, {});
}

// Organizer
export async function createTestLink(request: CreateLinkRequest): Promise<ShortLink> {
  return apiClient.post<ShortLink>('/organizer/test-links', request);
}

export async function listQuizLinks(assessmentId: string): Promise<ShortLink[]> {
  return apiClient.get<ShortLink[]>(`/organizer/test-links/assessment/${assessmentId}`);
}

export async function deactivateTestLink(linkId: string): Promise<void> {
  return apiClient.post<void>(`/organizer/test-links/${linkId}/deactivate`, {});
}
